import {$, handleESC, freeze, translationGuard} from '../utils/Utils';
import FocusHandler from '../utils/focus-handler';

const search = (() => {
  // we assume here that there'll be only:
  // only 1 input, 1 container, etc
  const config = {
    input: $('.js-searchInput')[0],
    showDismiss: [...$('.js-showSearchDismiss')],
    showTriggers: [...$('.js-showSearchTrigger')],
    showTarget: $('.js-showSearchTarget')[0],
    invalidCN: '-invalid',
    helperCN: 'js-inputHelper',
  };

  const focusHandler = new FocusHandler(config.showTarget);

  const handleTab = (event) => {
    if (event.key === 'Tab') {
      focusHandler.maintainFocus(event);
    }
  };

  const handleTabWithin = () => {
    focusHandler.focusFirstFocusable(config.input);
    document.addEventListener('keydown', handleTab);
  };

  const handleHide = () => {
    config.showTarget.classList.remove('-show');
    // stop listening ESC pressing
    handleESC.stop();
    // unfreeze window
    freeze.stop();
    // it does what it says
    focusHandler.focusLastActiveElement();
    // stop handling tab within
    document.removeEventListener('keydown', handleTab);
  };

  const handleShow = () => {
    // disable scroll on HTML
    freeze.start();
    // show search
    config.showTarget.classList.add('-show');
    // handle ESC button
    handleESC.init(handleHide);
    // handle tab within search container
    handleTabWithin();
  };

  const handleSubmit = (e) => {
    if(!config.input.value) {
      e.preventDefault();
      config.input.parentElement.classList.add(config.invalidCN);
      const helper = config.input.parentElement.querySelector('span.' + config.helperCN);
      helper.innerHTML = translationGuard("Ange sökord för att söka på sidan");
      return false;
    }
    config.input.parentElement.classList.remove(config.invalidCN);
    return true;
  };

  const build = () => {
    // listen on click onto the magnifying glass in the header
    if(config.showTarget) {
      config.showTarget.addEventListener('submit', (e) => handleSubmit(e));
    }

    if (config.showTriggers.length > 0) {
      config.showTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => handleShow());
      });
    }

    // close if dismiss (X) is pressed
    if (config.showDismiss.length > 0) {
      config.showDismiss.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          handleHide();
        });
      });
    }
  };

  const init = () => {
    build();
  };

  return {
    init,
  };
})();

export default search.init();
